import React from "react";
import Header from "../components/header.jsx";
import { Button } from "../components/utils/button.jsx";

import Professor1 from "../assets/professors/C3043.jpeg";
import Professor2 from "../assets/professors/C5227.jpeg";
import { useNavigate } from "react-router-dom";

function Contact() {
  const navigate = useNavigate();
  const user = {
    isAlumniCoordinator:
      localStorage.getItem("is_alumni_coordinator") === "true",
    isPricipal: localStorage.getItem("is_principal") === "true",
    department: localStorage.getItem("department"),
    isHod: localStorage.getItem("is_hod") === "true",
    isNMC: localStorage.getItem("is_nmc") === "true",
  };
  return (
    <div>
      {user.isAlumniCoordinator ||
      user.isPricipal ||
      user.isHod ||
      user.isNMC ||
      localStorage.getItem("token") ? (
        <Header
          NoProfileIcon={false}
          contact={true}
          resetPassAlumni={true}
          resetPass={true}
        />
      ) : (
        <Header
          NoProfileIcon={true}
          contact={true}
          resetPassAlumni={true}
          resetPass={true}
        />
      )}
      <div className="h-[100%] p-4">
        <div className="flex">
          <div className="flex flex-col items-center justify-center w-full pt-16 sm:p-10">
            <h1 className="mt-[70px] font-bold lg:text-[2rem] text-[1.7rem] text-center">
              Contacts
            </h1>
            <div className="flex flex-col gap-8 items-stretch justify-center w-full text-2xl sm:flex-row pt-12 text-center">
              <span>
                yamaward@psgtech.ac.in
              </span>
              <span>
                ecampus@psgtech.ac.in
              </span>
            </div>
            <Button
              className="mt-8 flex items-center justify-center w-[20%] font-semibold"
              type="secondary"
              onClick={() => {
                if (user.isAlumniCoordinator || user.isHod || user.isPricipal) {
                  navigate("/view-applicants");
                } else if (user.isNMC) {
                  navigate("/nmc-page");
                } else if (localStorage.getItem("token")) {
                  navigate("/personal-details");
                } else {
                  navigate("/nominate");
                }
              }}
            >
              Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
